export enum EMediaDataTypes {
	FILE = 'file',
}
